import React, { useCallback } from "react";
import { Snackbar, Alert, AlertColor } from "@mui/material";

interface ToasterProps {
  message: string;
  severity?: AlertColor;
  open: boolean;
  onClose: () => void;
  duration?: number;
}

const Toaster: React.FC<ToasterProps> = ({ message, severity = "info", open, onClose, duration = 6000 }) => {
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Snackbar open={open} autoHideDuration={duration} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Toaster;
